import { useSelector } from "react-redux";

import { getClassificationSegments } from "../../../../ducks/classification/selectors";
import { getSelectedSegment } from "../../../../ducks/style/selectors";
import { ClassificationState } from "../../../../ducks/classification/classification";

export const useClassificationSegment = (): ClassificationState => {
  const selectedSegment = useSelector(getSelectedSegment);
  const segments = useSelector(getClassificationSegments);

  return segments?.[selectedSegment];
};
